window.myStore = {};

function canUseWebP(){
    var elem = document.createElement('canvas');
    if (!!(elem.getContext && elem.getContext('2d'))) {
        return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    }
    return false;
}

(function ($) {

    if (!canUseWebP()) {
        $('body').addClass('no-webp');
    }

    !function (t) {
        var i = t(window);
        t.fn.visible = function (t, e, o) {
            if (!(this.length < 1)) {
                var r = this.length > 1 ? this.eq(0) : this, n = r.get(0), f = i.width(), h = i.height(), o = o ? o : "both", l = e === !0 ? n.offsetWidth * n.offsetHeight : !0;
                if ("function" == typeof n.getBoundingClientRect) {
                    var g = n.getBoundingClientRect(), u = g.top >= 0 && g.top < h, s = g.bottom > 0 && g.bottom <= h, c = g.left >= 0 && g.left < f, a = g.right > 0 && g.right <= f, v = t ? u || s : u && s, b = t ? c || a : c && a;
                    if ("both" === o)
                        return l && v && b;
                    if ("vertical" === o)
                        return l && v;
                    if ("horizontal" === o)
                        return l && b
                } else {
                    var d = i.scrollTop(), p = d + h, w = i.scrollLeft(), m = w + f, y = r.offset(), z = y.top, B = z + r.height(), C = y.left, R = C + r.width(), j = t === !0 ? B : z, q = t === !0 ? z : B, H = t === !0 ? R : C, L = t === !0 ? C : R;
                    if ("both" === o)
                        return!!l && p >= q && j >= d && m >= L && H >= w;
                    if ("vertical" === o)
                        return!!l && p >= q && j >= d;
                    if ("horizontal" === o)
                        return!!l && m >= L && H >= w
                }
            }
        }
    }(jQuery);

    $(document).ready(function ($) {

	    /**
	     * Hide menu on scroll down
	     */
	    const bodyel = document.body;
	    const scrollUp = "scroll-up";
	    const scrollDown = "scroll-down";
	    const navbar = document.getElementById('layout-nav');
	    let navbarHeight = 0;

        if (navbar !== null) {
            navbarHeight = navbar.getBoundingClientRect().height;
        }
	    let lastScroll = 0;

	    function setBodyScrollClass() {
		    const currentScroll = window.pageYOffset;
		    if (currentScroll <= 0) {
			    bodyel.classList.remove(scrollUp);
			    return;
		    }

		    if (( currentScroll > lastScroll && !bodyel.classList.contains(scrollDown)) && window.scrollY > navbarHeight ) {
			    // down
			    bodyel.classList.remove(scrollUp);
			    bodyel.classList.add(scrollDown);
		    } else if ( currentScroll < lastScroll && bodyel.classList.contains(scrollDown) ) {
			    // up
			    bodyel.classList.remove(scrollDown);
			    bodyel.classList.add(scrollUp);
		    }

		    if ( window.scrollY < navbarHeight ) {
			    bodyel.classList.remove(scrollDown);
			    bodyel.classList.remove(scrollUp);
		    }
		    lastScroll = currentScroll;
	    }

	    // Remove body classes even if it's frozen
	    $('body').each(function () {
		    setInterval(function () {
			    if ( window.scrollY < navbarHeight ) {
				    bodyel.classList.remove(scrollDown);
				    bodyel.classList.remove(scrollUp);
			    }
		    },1000);
	    });

	    window.addEventListener('scroll', setBodyScrollClass, false);


        /* Fill hidden Referral field */

        $('form.wpcf7-form').each(function () {
            if ($(this).find('[name="Referral URL"]').length == 0) {
                $(this).append('<input name="Referral URL" type="hidden" />');
            }
            $(this).find('[name="Referral URL"]').val(window.location.href);
        });


        /* Redrect to thenk you page from JSON response */

        $(document).on('wpcf7mailsent', function (event) {
            if (validURL(event.detail.apiResponse.message)) {
                window.location = event.detail.apiResponse.message;
            }
        });


        /* Focus on form when modal is shown */

        var elements = document.getElementsByClassName("modal");

        var myFunction = function(e) {
            var firstInput = e.target.querySelector('input:not(.wpcf7-hidden):not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="reset"])');

            if (firstInput) {
                setTimeout(function() { firstInput.focus() }, 500);
            }

        };

        if (elements.length > 0) {
            for (var i = 0; i < elements.length; i++) {
                elements[i].addEventListener('shown.bs.modal', myFunction, false);
            }
        }

        /* Load videos when they are visible */

        $(document).on('scroll', function (e) {
            $('[data-video-src]').each(function () {
                if ($(this).visible(true)) {
                    $(this).attr('src', $(this).attr('data-video-src')).removeAttr('data-video-src');
                }
            });
        }).trigger('scroll');

        var body = $('body');
        var popup = getParameterByName('popup');

        $.fn.isVisible = function () {
            var rect = this[0].getBoundingClientRect();
            return (
                    (rect.height > 0 || rect.width > 0) &&
                    rect.bottom >= 0 &&
                    rect.right >= 0 &&
                    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
                    );
        };


        if (popup == 1) {
            var contactModal = new bootstrap.Modal(document.getElementById("contactModal"), {});
            contactModal.show();
        }

        [].slice.call(document.querySelectorAll('select.cs-select')).forEach(function (el) {
            new SelectFx(el);
        });

        $(document).on('click', function (event) {
            var clickover = $(event.target);
            var _opened = $('.navbar-collapse').hasClass('in');
            if (_opened === true && !clickover.hasClass('navbar-toggle')) {
                $('button.navbar-toggle').click();
            }
        });

        $('#widget-toggle').click(function () {
            if ($('.form-widget').hasClass('collapsed')) {
                $('.form-widget').removeClass('collapsed')
            } else {
                $('.form-widget').addClass('collapsed')
            }
        });

        /* Navigation Bar*/

        $('.navbar-toggler').click(function () {
            body.toggleClass('backdrop');
        });


        $('.g-recaptcha', '#contactModal').click(function () {
            $(':focus', '#contactModal').blur();
        });

        function isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        }

        function getParameterByName(name, url) {
            if (!url)
                url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
            if (!results)
                return null;
            if (!results[2])
                return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        /* Sticky nav scroll */

        $('.values-container a').click(function (e) {
            e.preventDefault();

            $(this).parent().parent().find("li").removeClass('active');
            $(this).parent().addClass("active");

            var el = $(this).attr('href');
            var target = $(el);
            var currentOffsettop = $(this).offset().top;
            var targetOffsettop = $(target).offset().top;
            var offset;

            if ( targetOffsettop > currentOffsettop ) {
                offset = $(".nav-sticky").height() - 2;
            } else {
                offset = $(".nav-sticky").height() + $('#layout-nav').height() - 2;
            }
            offset = isMobile() ? offset - 50 : offset;

            $('html, body').animate({
                scrollTop: target.offset().top - offset
            }, {
                duration: 300,
                step: function (now, fx) {
                    var newOffset = target.offset().top - offset;
                    if (fx.end !== newOffset)
                        fx.end = newOffset;
                }
            });
        });

        function validURL(str) {
            var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
                    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                    '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
            return !!pattern.test(str);
        }


    });

    $('#twitter-widget').on('prescrolled', function () {
        var $height = 510;
        var $width = $(this).closest(".widget").width();

        /* Set widget height on the blog page and tablet resolutions */
        if ($(this).data().location === "blog" && (window.innerWidth > 700 && window.innerWidth < 1200)) {
            $height = 700;
        }
        $('#twitter-widget').append('<a class="twitter-timeline" data-width=' + $width + ' data-height="' + $height + '" href="https://twitter.com/bankassociates?ref_src=twsrc%5Etfw">Tweets by BAMS</a>');
        $.getScript('https://platform.twitter.com/widgets.js');
    });

    /* Validation rules */
    jQuery.validator.addMethod("userName", function (name, element) {
        return this.optional(element) || /^([a-zA-Z0-9 .`'\-](\.|\s|\.\s|\-|['`’.])?)*[a-zA-Z0-9 .`'\-]+$/g.test(name);
    }, 'Not a valid name');

    jQuery.validator.addMethod("companyName", function (company, element) {
        return this.optional(element) || /^([a-zA-Z0-9!@#$%^&*()_+-:";',./<>? ](\.|\s|\.\s|\-|['`’])?)*[a-zA-Z!#$%&'*+-/=?^_`{|}~@\-.+ \d]+$/g.test(company);
    }, 'Not a valid company name');

    jQuery.validator.addMethod("phoneUS", function (phone_number, element) {
        phone_number = phone_number.replace(/\s+/g, "");
        return this.optional(element) || (phone_number.length >= 10 &&
                /^(201|202|203|204|205|206|207|208|209|210|212|213|214|215|216|217|218|219|220|223|224|225|226|228|229|231|234|236|239|240|242|246|248|249|250|251|252|253|254|256|260|262|264|267|268|269|270|272|276|279|281|284|289|301|302|303|304|305|306|307|308|309|310|312|313|314|315|316|317|318|319|320|321|323|325|326|330|331|332|334|336|337|339|340|341|343|345|346|347|351|352|360|361|364|365|367|380|385|386|401|402|403|404|405|406|407|408|409|410|412|413|414|415|416|417|418|419|423|424|425|430|431|432|434|435|437|438|440|441|442|443|445|450|456|458|463|469|470|473|475|478|479|480|484|500|501|502|503|504|505|506|507|508|509|510|512|513|514|515|516|517|518|519|520|530|531|533|534|539|540|541|544|548|551|559|561|562|563|564|566|567|570|571|573|574|575|577|579|580|581|585|586|587|600|601|602|603|604|605|606|607|608|609|610|612|613|614|615|616|617|618|619|620|623|626|628|629|630|631|636|639|640|641|646|647|649|650|651|657|658|659|660|661|662|664|667|669|670|671|672|678|680|681|682|684|689|700|701|702|703|704|705|706|707|708|709|710|712|713|714|715|716|717|718|719|720|721|724|725|726|727|731|732|734|737|740|743|747|754|757|758|760|762|763|765|767|769|770|772|773|774|775|778|779|780|781|782|784|785|786|787|800|801|802|803|804|805|806|807|808|809|810|812|813|814|815|816|817|818|819|820|825|828|829|830|831|832|833|838|839|843|844|845|847|848|849|850|854|855|856|857|858|859|860|862|863|864|865|866|867|868|869|870|872|873|876|877|878|888|900|901|902|903|904|905|906|907|908|909|910|911|912|913|914|915|916|917|918|919|920|925|928|929|930|931|934|936|937|938|939|940|941|947|949|951|952|954|956|959|970|971|972|973|978|979|980|984|985|986|989)(\-)?[0-9]{3}(\-)?[0-9]{4}$/.test(phone_number));
    }, 'Please use only US numbers (eg: 5157891212)');

    jQuery.validator.addMethod("companyEmail", function (value, element) {
        return this.optional(element) || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@[a-zA-Z0-9]+((\-?[a-zA-Z0-9]{1,})|(\.?[a-zA-Z0-9]+\-?[a-zA-Z0-9]+))*(\.{1}[a-zA-Z]{2,})$/gm.test(value);
    }, 'Not a valid email (eg: example@mail.com)');

    window.myStore.rules = {
        firstname: {
            required: true,
            userName: true
        },
        lastname: {
            required: true,
            userName: true
        },
        company: {
            required: true,
            companyName: true
        },
        email: {
            required: true,
            maxlength: 63,
            companyEmail: true
        },
        phone: {
            required: true,
            phoneUS: true
        },
        question1: {
            required: true
        },
        experience: {
            required: true
        },
        merchants: {
            required: true
        },
        method: {
            required: true
        },
    };

    window.myStore.messages = {
        firstname: {
            required: "Please enter your name",
            userName: "Not a valid name"
        },
        lastname: {
            required: "Please enter your last name",
            userName: "Not a valid name"
        },
        company: {
            required: "Please enter your company name",
            companyName: "Not a valid company name"
        },
        email: {
            required: "Please enter your email",
            companyEmail: "Not a valid email (eg: example@mail.com)"
        },
        phone: {
            required: "Please enter your phone (eg: 5157891212)",
            maxlength: 10,
            phoneUS: "Please use only US numbers (eg: 5157891212)"
        },
    };

    window.myStore.validatorOptions = {
        focusCleanup: true,
        focusInvalid: false,
        onfocusout: function (el, ev) {
            // "eager" validation
            this.element(el);
            let value = $(el).val().trim();
            $(el).val(value);
            return this.element(el);
        },
        rules: window.myStore.rules,
        messages: window.myStore.custom_messages
    };

    window.myStore.custom_validation = {
        translation: {
            'N': {pattern: /^[a-zA-Z0-9 .`'\-]/, optional: true, recursive: true},
            'C': {pattern: /^[a-zA-Z0-9 .`!@#$%^&*()_+-:";',/<>?]/, optional: true, recursive: true},
            'M': {pattern: /[a-zA-Z0-9!#$%&'*+-/=?^_`{|}~@\-.+ ]/, optional: true, recursive: true}
        },
        maxlength: false
    };

    /* Request Quote Form Jquery validation */

    var validateCF = $('#contactModal form.wpcf7-form');
    var validator = validateCF.validate(window.myStore.validatorOptions);

    $('#contactModal form.wpcf7-form input[type=submit]').on('click', function (e) {
        var validated = validateCF.valid();
        if (!validated) {
            e.preventDefault();
        }
    });

    $('#contactModal form.wpcf7-form input[type=tel]').mask('000-000-0000');

    $('#contactModal form.wpcf7-form input[type=tel]').on("focus", function () {
        $(this).attr("placeholder", "222-222-2222");
    });

    $('#contactModal form.wpcf7-form input[type=tel]').on("blur", function () {
        $(this).attr("placeholder", "");
    });

    $('#contactModal form.wpcf7-form input[name=firstname]').mask('N', window.myStore.custom_validation);
    $('#contactModal form.wpcf7-form input[name=company]').mask('C', window.myStore.custom_validation);
    $('#contactModal form.wpcf7-form input[name=email]').mask('M', window.myStore.custom_validation);


    /* Download Form Jquery validation */

    var validateCF = $('#downloadModal form.wpcf7-form');
    var validator = validateCF.validate(window.myStore.validatorOptions);

    $('#downloadModal form.wpcf7-form input[type=submit]').on('click', function (e) {
        var validated = validateCF.valid();
        if (!validated) {
            e.preventDefault();
        }
    });

    $('#downloadModal form.wpcf7-form input[type=tel]').mask('000-000-0000');

    $('#downloadModal form.wpcf7-form input[type=tel]').on("focus", function () {
        $(this).attr("placeholder", "222-222-2222");
    });

    $('#downloadModal form.wpcf7-form input[type=tel]').on("blur", function () {
        $(this).attr("placeholder", "");
    });

    $('#downloadModal form.wpcf7-form input[name=firstname]').mask('N', window.myStore.custom_validation);
    $('#downloadModal form.wpcf7-form input[name=company]').mask('C', window.myStore.custom_validation);
    $('#downloadModal form.wpcf7-form input[name=email]').mask('M', window.myStore.custom_validation);

    /* Home Banner Form Jquery validation */

    var validateHBF = $('#home-banner form.wpcf7-form');
    var validator = validateHBF.validate(window.myStore.validatorOptions);

    $('#home-banner form.wpcf7-form input[type=submit]').on('click', function (e) {
        var validated = validateHBF.valid();
        if (!validated) {
            e.preventDefault();
        }
    });

    $('#home-banner form.wpcf7-form input[type=tel]').mask('000-000-0000');

    $('#home-banner form.wpcf7-form input[type=tel]').on("focus", function () {
        $(this).attr("placeholder", "222-222-2222");
    });

    $('#home-banner form.wpcf7-form input[type=tel]').on("blur", function () {
        $(this).attr("placeholder", "");
    });

    $('#home-banner form.wpcf7-form input[name=firstname]').mask('N', window.myStore.custom_validation);
    $('#home-banner form.wpcf7-form input[name=company]').mask('C', window.myStore.custom_validation);
    $('#home-banner form.wpcf7-form input[name=email]').mask('M', window.myStore.custom_validation);


    /* Banner Form */

    var validateBF = $('.banner-form-container form.wpcf7-form');
    var validator = validateBF.validate(window.myStore.validatorOptions);

    $('.banner-form-container form.wpcf7-form input[type=submit]').on('click', function (e) {
        var validated = validateBF.valid();
        if (!validated) {
            e.preventDefault();
        }
    });

    $('.banner-form-container form.wpcf7-form input[type=tel]').mask('000-000-0000');

    $('.banner-form-container form.wpcf7-form input[type=tel]').on("focus", function () {
        $(this).attr("placeholder", "222-222-2222");
    });

    $('.banner-form-container form.wpcf7-form input[type=tel]').on("blur", function () {
        $(this).attr("placeholder", "");
    });

    $('.banner-form-container form.wpcf7-form input[name=firstname]').mask('N', window.myStore.custom_validation);
    $('.banner-form-container form.wpcf7-form input[name=company]').mask('C', window.myStore.custom_validation);
    $('.banner-form-container form.wpcf7-form input[name=email]').mask('M', window.myStore.custom_validation);

    /* Affiliates Modal */

    var validateAM = $('#affiliateModal form.wpcf7-form');
    var validator = validateAM.validate(window.myStore.validatorOptions);

    $('#affiliateModal form.wpcf7-form input[type=submit]').on('click', function (e) {
        var validated = validateAM.valid();
        if (!validated) {
            e.preventDefault();
        }
    });

    $('#affiliateModal form.wpcf7-form input[type=tel]').mask('000-000-0000');

    $('#affiliateModal form.wpcf7-form input[type=tel]').on("focus", function () {
        $(this).attr("placeholder", "222-222-2222");
    });

    $('#affiliateModal form.wpcf7-form input[type=tel]').on("blur", function () {
        $(this).attr("placeholder", "");
    });

    $('#affiliateModal form.wpcf7-form input[name=firstname]').mask('N', window.myStore.custom_validation);
    $('#affiliateModal form.wpcf7-form input[name=company]').mask('C', window.myStore.custom_validation);
    $('#affiliateModal form.wpcf7-form input[name=email]').mask('M', window.myStore.custom_validation);


    /* Sticky navbar */

    $(document).on('scroll', function (e) {
        var scroll = $(window).scrollTop();
        var elementScroll = scroll + $(window).height() + 50;
        $('.scrollChecker').each(function () {
            // old fixed nav // var toHeaderScrollPosition = ($(this).offset().top - $('#layout-nav').outerHeight() - (($('#wpadminbar').length > 0) ? $('#wpadminbar').outerHeight() : 0));
            var toHeaderScrollPosition = ($(this).offset().top - (($('#wpadminbar').length > 0) ? $('#wpadminbar').outerHeight() : 0));
            if (elementScroll > $(this).offset().top) {
                if (!$(this).hasClass('prescrolled')) {
                    $(this).addClass('prescrolled');
                    $(this).trigger('prescrolled');
                }
            }
            if (elementScroll > ($(this).offset().top + ($(this).height() * 0.9)) && scroll < $(this).offset().top + ($(this).height() * 0.1)) {
                if (!$(this).hasClass('scrolled')) {
                    $(this).addClass('scrolled');
                    $(this).trigger('scrolled');
                }
            }

            if (scroll > toHeaderScrollPosition-5) {
                $(this).trigger('stickyheader:on');
            }
            if (scroll <= toHeaderScrollPosition-5) {
                $(this).trigger('stickyheader:off');
            }
        });
    }).trigger('scroll');


    /* Validation from old app.js file */

    jQuery.validator.addMethod("userName", function (name, element) {
        return this.optional(element) || /^([a-zA-Z0-9 .`'\-](\.|\s|\.\s|\-|['`’.])?)*[a-zA-Z0-9 .`'\-]+$/g.test(name);
    }, 'Not a valid name');

    jQuery.validator.addMethod("companyName", function (company, element) {
        return this.optional(element) || /^([a-zA-Z0-9!@#$%^&*()_+-:";',./<>? ](\.|\s|\.\s|\-|['`’])?)*[a-zA-Z!#$%&'*+-/=?^_`{|}~@\-.+ \d]+$/g.test(company);
    }, 'Not a valid company name');

    jQuery.validator.addMethod("phoneUS", function (phone_number, element) {
        phone_number = phone_number.replace(/\s+/g, "");
        return this.optional(element) || (phone_number.length >= 10 &&
            /^(201|202|203|204|205|206|207|208|209|210|212|213|214|215|216|217|218|219|220|223|224|225|226|228|229|231|234|236|239|240|242|246|248|249|250|251|252|253|254|256|260|262|264|267|268|269|270|272|276|279|281|284|289|301|302|303|304|305|306|307|308|309|310|312|313|314|315|316|317|318|319|320|321|323|325|326|330|331|332|334|336|337|339|340|341|343|345|346|347|351|352|360|361|364|365|367|380|385|386|401|402|403|404|405|406|407|408|409|410|412|413|414|415|416|417|418|419|423|424|425|430|431|432|434|435|437|438|440|441|442|443|445|450|456|458|463|469|470|473|475|478|479|480|484|500|501|502|503|504|505|506|507|508|509|510|512|513|514|515|516|517|518|519|520|530|531|533|534|539|540|541|544|548|551|559|561|562|563|564|566|567|570|571|573|574|575|577|579|580|581|585|586|587|600|601|602|603|604|605|606|607|608|609|610|612|613|614|615|616|617|618|619|620|623|626|628|629|630|631|636|639|640|641|646|647|649|650|651|657|658|659|660|661|662|664|667|669|670|671|672|678|680|681|682|684|689|700|701|702|703|704|705|706|707|708|709|710|712|713|714|715|716|717|718|719|720|721|724|725|726|727|731|732|734|737|740|743|747|754|757|758|760|762|763|765|767|769|770|772|773|774|775|778|779|780|781|782|784|785|786|787|800|801|802|803|804|805|806|807|808|809|810|812|813|814|815|816|817|818|819|820|825|828|829|830|831|832|833|838|839|843|844|845|847|848|849|850|854|855|856|857|858|859|860|862|863|864|865|866|867|868|869|870|872|873|876|877|878|888|900|901|902|903|904|905|906|907|908|909|910|911|912|913|914|915|916|917|918|919|920|925|928|929|930|931|934|936|937|938|939|940|941|947|949|951|952|954|956|959|970|971|972|973|978|979|980|984|985|986|989)(\-)?[0-9]{3}(\-)?[0-9]{4}$/.test(phone_number));
    }, 'Please use only US numbers (eg: 5157891212)');

    jQuery.validator.addMethod("companyEmail",	function (value, element) {
        return this.optional(element) || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@[a-zA-Z0-9]+((\-?[a-zA-Z0-9]{1,})|(\.?[a-zA-Z0-9]+\-?[a-zA-Z0-9]+))*(\.{1}[a-zA-Z]{2,})$/gm.test(value);
    }, 'Not a valid email (eg: example@mail.com)');

    var rules = {
        firstname: {
            required: true,
            userName: true
        },
        lastname: {
            required: true,
            userName: true
        },
        company: {
            required: true,
            companyName: true
        },
        dba: {
            required: true,
            companyName: true
        },
        email: {
            required: true,
            maxlength: 63,
            companyEmail: true
        },
        phone: {
            required: true,
            phoneUS: true
        },
        question1: {
            required: true
        },
        experience: {
            required: true
        },
        merchants: {
            required: true
        },
        method: {
            required: true
        },
        streetaddress: {
            required: true
        },
        city: {
            required: true
        },
        state: {
            required: true
        },
        zip: {
            required: true
        },
    };

    var messages = {
        firstname: {
            required: "Please enter your name",
            userName: "Not a valid name"
        },
        lastname: {
            required: "Please enter your last name",
            userName: "Not a valid name"
        },
        company: {
            required: "Please enter your company name",
            companyName: "Not a valid company name"
        },
        dba: {
            required: "Please enter your company name",
            companyName: "Not a valid company name"
        },
        email: {
            required: "Please enter your email",
            companyEmail: "Not a valid email (eg: example@mail.com)"
        },
        phone: {
            required: "Please enter your phone (eg: 5157891212)",
            maxlength: 10,
            phoneUS: "Please use only US numbers (eg: 5157891212)"
        },
    };

    var validatorOptions = {
        focusCleanup: true,
        focusInvalid: false,
        onfocusout: function(el, ev) {
            // "eager" validation
            this.element(el);
            let value = $(el).val().trim();
            $(el).val(value);
            return this.element(el);
        },
        rules: rules,
        messages: messages
    };

    var custom_validation = {
        translation: {
            'N': { pattern: /^[a-zA-Z0-9 .`'\-]/, optional: true, recursive: true },
            'C': { pattern: /^[a-zA-Z0-9 .`!@#$%^&*()_+-:";',/<>?]/, optional: true, recursive: true },
            'M': { pattern: /[a-zA-Z0-9!#$%&'*+-/=?^_`{|}~@\-.+ ]/, optional: true, recursive: true }
        },
        maxlength: false
    };


    /* Henriquez form */
    var validateHF = $('form#henriquez_form');

    var validator = validateHF.validate(validatorOptions);

    $('form#henriquez_form input[type=submit]').on('click', function (e) {
        var validated = validateHF.valid();
        if (!validated) {
            e.preventDefault();
        }
    });


    $('form#henriquez_form input[name=firstname]').mask( 'N', custom_validation );

    $('form#henriquez_form input[name=lastname]').mask( 'N', custom_validation );

    $('form#henriquez_form input[name=email]').mask( 'M', custom_validation );

    $('form#henriquez_form input[name=dba]').mask( 'C', custom_validation );




    /* Contact Form Module */

    var validateCFM = $('#contactFormModule form.wpcf7-form');

    var validator = validateCFM.validate(validatorOptions);

    $('#contactFormModule form.wpcf7-form input[type=submit]').on('click', function (e) {
        var validated = validateCFM.valid();
        if (!validated) {
            e.preventDefault();
        }
    });

    $('#contactFormModule form.wpcf7-form input[type=tel]').mask('000-000-0000');

    $('#contactFormModule form.wpcf7-form input[type=tel]').on("focus", function () {
        $(this).attr("placeholder","222-222-2222");
    });

    $('#contactFormModule form.wpcf7-form input[type=tel]').on("blur", function () {
        $(this).attr("placeholder","");
    });

    $('#contactFormModule form.wpcf7-form input[name=firstname]').mask( 'N', custom_validation );

    $('#contactFormModule form.wpcf7-form input[name=lastname]').mask( 'N', custom_validation );

    $('#contactFormModule form.wpcf7-form input[name=company]').mask( 'C', custom_validation );

    $('#contactFormModule form.wpcf7-form input[name=email]').mask( 'M', custom_validation );


    /* Application Form */

    var validateAF = $('#apply form.wpcf7-form');

    var validator = validateAF.validate(validatorOptions);

    $('#apply form.wpcf7-form input[type=submit]').on('click', function (e) {
        var validated = validateAF.valid();
        if (!validated) {
            e.preventDefault();
        }
    });

    $('#apply form.wpcf7-form input[type=tel]').mask('000-000-0000');

    $('#apply form.wpcf7-form input[type=tel]').on("focus", function () {
        $(this).attr("placeholder","222-222-2222");
    });

    $('#apply form.wpcf7-form input[type=tel]').on("blur", function () {
        $(this).attr("placeholder","");
    });

    $('#apply form.wpcf7-form input[name=firstname]').mask( 'N', custom_validation );

    $('#apply form.wpcf7-form input[name=company]').mask( 'C', custom_validation );

    $('#apply form.wpcf7-form input[name=email]').mask( 'M', custom_validation );


    /* Affiliates Modal */

    var validateAM = $('#affiliateModal form.wpcf7-form');

    var validator = validateAM.validate(validatorOptions);

    $('#affiliateModal form.wpcf7-form input[type=submit]').on('click', function (e) {
        var validated = validateAM.valid();
        if (!validated) {
            e.preventDefault();
        }
    });

    $('#affiliateModal form.wpcf7-form input[type=tel]').mask('000-000-0000');

    $('#affiliateModal form.wpcf7-form input[type=tel]').on("focus", function () {
        $(this).attr("placeholder","222-222-2222");
    });

    $('#affiliateModal form.wpcf7-form input[type=tel]').on("blur", function () {
        $(this).attr("placeholder","");
    });

    $('#affiliateModal form.wpcf7-form input[name=firstname]').mask( 'N', custom_validation );

    $('#affiliateModal form.wpcf7-form input[name=company]').mask( 'C', custom_validation );

    $('#affiliateModal form.wpcf7-form input[name=email]').mask( 'M', custom_validation );


    /* Sign up for consultation */

    var validateSUFC = $('.sign_up_for_consultation form.wpcf7-form');

    var validator = validateSUFC.validate(validatorOptions);

    $('.sign_up_for_consultation form.wpcf7-form input[type=submit]').on('click', function (e) {
        var validated = validateSUFC.valid();
        if (!validated) {
            e.preventDefault();
        }
    });

    $('.sign_up_for_consultation form.wpcf7-form input[name=firstname]').mask( 'N', custom_validation );

    $('.sign_up_for_consultation form.wpcf7-form input[name=lastname]').mask( 'N', custom_validation );

    $('.sign_up_for_consultation form.wpcf7-form input[name=email]').mask( 'M', custom_validation );




    $(document).ready(function ($) {

        $('#referral-form').validate();

        $('.next-step').click(function (e) {
            e.preventDefault();
            var el = $(this).data('step');

            var myCollapse = document.getElementById(el.slice(1));
            var bsCollapse = new bootstrap.Collapse(myCollapse, {
                toggle: true
            });

            bsCollapse.show();

            var elHeight = $(el).height();
            var elOffset = $(el).offset().top;
            var windowHeight = $(window).height();

            $('html, body').animate({
                scrollTop: elOffset - (windowHeight / 2)
            }, 250);
        });

    });

    var videoModal = document.getElementById('video-modal');
    var quickbooksVideo = document.getElementById('quickbooks-video');
    if (videoModal) {
        videoModal.addEventListener('show.bs.modal', function (event) {
            // Button that triggered the modal
            var button = event.relatedTarget;
            // Extract info from data-bs-* attributes
            var video = button.getAttribute('data-video');

            quickbooksVideo.src = 'https://player.vimeo.com/video/'+video+'?title=0&amp;byline=0&amp;portrait=0&amp;autoplay=1&quality=1080p';
        })

        videoModal.addEventListener('hide.bs.modal', function (event) {
            quickbooksVideo.src = '';
        })
    }

})(jQuery);
